import { Button, Input, Space } from "antd";
import React from "react";

const VendorSearch = ({ searchParams, setSearchParams, onSearch }) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSearch({ page: 1 });
      }}
    >
      <Space>
        <Input
          placeholder="Search Vendor"
          value={searchParams.name}
          onChange={(e) =>
            setSearchParams({ ...searchParams, search: e.target.value })
          }
          allowClear
        />
        <Button type="primary" htmlType="submit">
          Search
        </Button>
        <Button
          onClick={() => {
            setSearchParams({ ...searchParams, search: "" });
            onSearch();
          }}
        >
          Reset
        </Button>
      </Space>
    </form>
  );
};

export default VendorSearch;
